import { Fragment, memo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import FormCertificate, { CertificateForm } from 'front-office/components/released-services/form';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonCertificateCrumbs } from '../constants';
import { toast } from 'react-toastify';
import { HttpResponse } from 'shell/models/http-response';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { transformCertificate } from 'front-office/components/released-services/utils/transform-certificate';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { ReleasedService } from 'shell/models/certificate';
import { useEventCallback } from '@mui/material';

const CertificatesRestorePageComponent = (): React.ReactElement => {
  const params = useParams();

  const navigate = useNavigate();
  const [certificate] = useHttpFetch<HttpResponse<ReleasedService>, CertificateForm>(
    `${__CERTIFICATION_API_URL__}/certificazione/registro-doc-rilasciati/${params.idSigla}/${params.idAnno}/${params.progressivo}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformCertificate,
    }
  );

  const restoreData = useHttpClient(
    `${__CERTIFICATION_API_URL__}/certificazione/registro-doc-rilasciati/ripristino/${params.idSigla}/${params.idAnno}/${params.progressivo}`,
    {
      options: {
        errorCatching: true,
        method: 'PUT',
        loading: true,
        data: {},
      },
    }
  );

  const onSubmit = useEventCallback(() => {
    (restoreData() as ResponsePromise<unknown>).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sportello/controllo-di-cassa');
    });
  });

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonCertificateCrumbs, { name: 'Ripristina Certificato' }]} />
      {certificate.isLoading || !certificate.data ? null : (
        <FormCertificate
          title="Ripristina Servizio rilasciato"
          onOk={onSubmit}
          onGoBack={() => {
            navigate('/sportello/controllo-di-cassa');
          }}
          disabled
          isRestore
          initialValues={certificate.data as CertificateForm}
        />
      )}
    </Fragment>
  );
};

CertificatesRestorePageComponent.displayName = 'Certificate Restore page component';

const CertificatesRestorePage = memo(CertificatesRestorePageComponent);

export default CertificatesRestorePage;
